import React from "react";
import Button from "../../../_components/Button";
import Modal from "../../../_components/Modal";
import Toast from "../../../_components/Toast";
import Text from "../../../_components/Text";
import Icon from "../../../_components/Icon";
import EasyButton from "../../../_components/Button/EasyButton";
import { startTrial } from "../../../api/financial/index.js";
import { formatDate } from "../../../utils/index.js";

function ActiveFinancialStartTrial() {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState({});
  const [toast, setToast] = React.useState({
    message: "",
    show: false,
    type: "erro",
  });
  const [show, setShow] = React.useState(false);

  function handleClick() {
    setLoading(true);
    startTrial()
      .then((resp) => {
        setData({
          startDate: formatDate(resp["activated!"].start),
          endDate: formatDate(resp["activated!"].end),
        });
        setShow(true);
        setInterval(() => {
          window.location.href = "financial/pay-out";
        }, 10000);
      })
      .catch((error) => {
        if (error === "module_already_activate") {
          setToast({
            show: true,
            message: "Já foi solicitado o teste grátis!",
          });
        } else {
          setLoading(false);
        }
        setShow(false);
      });
  }
  return (
    <React.Fragment>
      <div className="d-flex justify-content-center">
        <Button disabled={loading} as="text" onClick={handleClick}>
          Clique aqui para ter acesso grátis ao módulo financeiro
        </Button>
      </div>
      <Modal
        title="O Módulo financeiro foi liberado gratuitamente!"
        show={show}
      >
        <Text align="center">
          O seu perído de teste começa a partir de: {data.startDate} e vai até{" "}
          {data.endDate}
        </Text>
        <Text align="center">Bons negócios!</Text>
      </Modal>
      <Toast {...toast} />
    </React.Fragment>
  );
}

function Barcode() {
  return (
    <div className="d-flex justify-content-center">
      <Button as="text" onClick={() => (window.location.href = "/barcodes")}>
        Clique aqui para criar códigos de barras de graça
      </Button>
    </div>
  );
}
function Accounting() {
  return (
    <div className="d-flex justify-content-center">
      <Button as="text" onClick={() => (window.location.href = "/accounting")}>
        Clique aqui e cadastre seu contador
      </Button>
    </div>
  );
}
function NFe() {
  const [show, setShow] = React.useState(false);
  function open() {
    setShow(true);
  }
  function close() {
    setShow(false);
  }
  return (
    <React.Fragment>
      <div className="d-flex justify-content-center">
        <Button as="text" onClick={open}>
          Clique aqui e saiba mais
        </Button>
      </div>
      <Modal title="Novidades e correções na NF-e" show={show} onHide={close}>
        <Text>
          <Icon className="fas fa-check" /> Inclusão automática da base de
          cálculo para os CSON = 102, 103, 300, 400, 900
        </Text>
        <Text>
          <Icon className="fas fa-check" /> Ative o módulo financeiro e registre
          suas contas a receber de forma integrada com o emissor de NF-e
        </Text>
        <Text>
          <Icon className="fas fa-check" /> Correção no parcelamento de boletos
        </Text>
        <Text>
          <Icon className="fas fa-check" /> Correção da divergência entre o
          valor líquido e o valor da NF-e
        </Text>
        <Text>
          <Icon className="fas fa-check" /> Exibir o valor total dos itens no
          passo 2 da emissão de NF-e
        </Text>
      </Modal>
    </React.Fragment>
  );
}
function NFCe() {
  const [show, setShow] = React.useState(false);
  function open() {
    setShow(true);
  }
  function close() {
    setShow(false);
  }
  return (
    <React.Fragment>
      <div className="d-flex justify-content-center">
        <Button as="text" onClick={open}>
          Clique aqui e saiba mais
        </Button>
      </div>
      <Modal
        title="Novidades e correções em Vendas com NFC-e"
        show={show}
        onHide={close}
      >
        <Text>
          <Icon className="fas fa-check" /> Exibir as últimas 10 vendas com
          NFC-e
        </Text>
        <Text>
          <Icon className="fas fa-check" /> Cancelmanento de NFC-e pela tela de
          listagem de NFC-e
        </Text>
      </Modal>
    </React.Fragment>
  );
}

export default [
  {
    title: "Financeiro Grátis!",
    description: (
      <div>
        Chegou o módulo financeiro do EasyGestor, iremos liberar exclusivamente
        para você.
        <br />
        <i className="fas fa-check"></i> Não precisa nenhum pagamento prévio
        <br />
        <i className="fas fa-check"></i> Acesso imediato e em primeira mão
        <br />
        <i className="fas fa-check"></i> Cancelamento automático em 7 dias
        <br />
      </div>
    ),
    image: "",
    footer: <ActiveFinancialStartTrial />,
  },
  {
    title: "Utilize nossa IA financeira para ler recibos e organizar contas",
    description:
      "Utilize agora mesmo nossa IA financeira para ler os recibos e organizar melhor suas contas a pagar e receber",
    image: "",
    footer: <ActiveFinancialStartTrial />,
  },
  {
    title: "Código de barras gratuito!",
    description:
      "Mais um módulo novo adicionado ao Easygestor! E você pode usar de graça!",
    image: "https://easygestor.com/wp-content/uploads/2024/04/barcode-1.png",
    footer: <Barcode />,
  },
  {
    title: "Cadastre seu Contador.",
    description:
      "Cadastre seu contador e ganhe acesso gratuito ao nosso curso de marketing, entre outras vantagens!",
    image:
      "https://easygestor.com/wp-content/uploads/2024/04/DALL·E-2024-04-08-15.15.32-Create-an-image-of-two-professional-accountants-in-business-attire-one-male-and-one-female-shaking-hands-in-a-modern-office-environment.-They-are-pa.png",
    footer: <Accounting />,
  },
  {
    title: "De cara nova.",
    description:
      "O menu lateral mudou, agora ele está mais organizado para você não perder tempo!",
    image:
      "https://easygestor.com/wp-content/uploads/2024/04/DALL·E-2024-04-08-15.15.32-Create-an-image-of-two-professional-accountants-in-business-attire-one-male-and-one-female-shaking-hands-in-a-modern-office-environment.-They-are-pa.png",
  },
  {
    title: "Cadastre um produto durante a emissão da sua NF-e.",
    description:
      "Agora é possível cadastrar um produto diretamente na emissão de sua NFe, sem a necessidade de sair do emissor para isso!",
    image:
      "https://easygestor.com/wp-content/uploads/2024/04/DALL·E-2024-04-08-15.15.32-Create-an-image-of-two-professional-accountants-in-business-attire-one-male-and-one-female-shaking-hands-in-a-modern-office-environment.-They-are-pa.png",
  },

];



// WEBPACK FOOTER //
// ./src/views/AppViews/News/data.jsx